import user from "./user";
import app from "./app";
import pagination from "./pagination";
import dashboard from "./dashboard";

export default {
  ...user,
  ...app,
  ...dashboard,
  ...pagination,
};
